import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import WizardStepWrapperTemplate from 'Views/Page/Content/Templates/WizardTemplates/WizardStepWrapperTemplate';
import fr from 'facet-rest';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import { useKYC } from 'Hooks/Aggregators/useKYC';
import { buildFacetDesignOverride } from 'Packages/FacetRest/FacetDesignOverride';
import { KYCIntroStepLayout } from './layout';

export const OldKYCIntroStepContainer = ({ resource, linkTokenResource }) => {
  const { submitPageResource, setPageContentCollection } = usePageContentContext();
  const onKYCFinished = useCallback(async ({ externalID }) => {
    resource.attr('externalId', externalID);
    const { response, error } = await submitPageResource();
    if (!error && response) {
      setPageContentCollection(response);
    }
  }, [resource, submitPageResource, setPageContentCollection]);
  const { startKYC, initializationError, isInitialized } = useKYC({ resource: linkTokenResource, onKYCFinished });

  if (!isInitialized || initializationError) {
    return null;
  }

  return (
    <WizardStepWrapperTemplate
      metaOverrideSet={buildFacetDesignOverride()}
      resource={resource}
      layout={KYCIntroStepLayout}
      onNext={startKYC}
      primaryActionLabel="Continue"
    />
  );
};

OldKYCIntroStepContainer.defaultProps = {
};

OldKYCIntroStepContainer.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
  linkTokenResource: PropTypes.instanceOf(fr.Resource).isRequired,
};
